import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';


export default function RouteBasicInfoComponent({ handleInnerFormChange, selectedRoute, regions }: any) {
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Route Number"
              name="RouteNumber"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'RouteNumber',

                )
              }}
              type="number"
              value={selectedRoute?.RouteNumber}
            />
            <InputContainer

              label="Route Name"
              name="RouteName"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'RouteName',

                )
              }}
              type="text"
              value={selectedRoute?.RouteName}
            />
            <InputContainer
              label="Region "
              labelField="RegionName"
              list={regions}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'RegionId',
                  selectedRoute
                );
              }}
              optionName='Choose Region'
              type="select"
              value={selectedRoute?.RegionId}
              valueField="Id"
            />
          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Basic Info"
      />

    </>
  )
}